export const notificationMessage = {
    signUpSuccess: 'Rejestracja przebiegła pomyślnie. Możesz się zalogować.',
    resendCodeSuccess: 'Kod został wysłany ponownie. Sprawdź swoją skrzynkę oraz folder spam.',
    resendCodeLimit: 'Zbyt wiele próśb o kod. Zaczekaj 5 minut i spróbuj ponownie.',
};
